import { removeWithQueryParams } from '../../../../utils/api';
import { services } from '../../../../constants/services';

export class DeleteUploadReactionService {
  async run(fileUrl: string): Promise<void> {
    return removeWithQueryParams(
      `${services.files}/delete-file-by-url`,
      { fileUrl }
    );
  }
}
